import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
// normalize.css
import 'normalize.css/normalize.css'

createApp(App).use(router).mount('#app')
